/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_TestInputs */

const en_ai_test = /** @type {(inputs: Ai_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test connection`)
};

const de_ai_test = /** @type {(inputs: Ai_TestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung testen`)
};

/**
* | output |
* | --- |
* | "Test connection" |
*
* @param {Ai_TestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_test = /** @type {((inputs?: Ai_TestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_TestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_test(inputs)
	return en_ai_test(inputs)
});